module.exports = __webpack_public_path__ + "img/10021.0c37b252.jpg";